import { render, staticRenderFns } from "./servicesProject.vue?vue&type=template&id=4867cb41&scoped=true&lang=html&"
import script from "./servicesProject.vue?vue&type=script&lang=js&"
export * from "./servicesProject.vue?vue&type=script&lang=js&"
import style0 from "./servicesProject.vue?vue&type=style&index=0&id=4867cb41&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4867cb41",
  null
  
)

export default component.exports